
import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';

export class SaleServiceSearchModel extends SearchBaseModel {

  RegistrationNumber: string;
  CustomerId: number;
  GarageId: number;
  CustomerName: string;
  ServiceName: string;
  DateRange: DateRange;
  Period: any;
  IsInvoiceIssued: boolean;
  InvoiceNumber: string;
  GarageInvoiceNumber: string;

  constructor() {
    super();
    this.RegistrationNumber = null;
    this.CustomerId = null;
    this.CustomerName = null;
    this.ServiceName = null;
    this.DateRange = new DateRange();
    this.IsInvoiceIssued = null;
    this.InvoiceNumber = null;
    this.Period = null;
    }

}

